<template class="modal-coming-soon">
<b-modal id="coming-soon-modal" centered :hide-footer="true" :hide-header="true">
  <template v-slot:default="{ hide }">
    <p class="modal-title">Coming Soon</p>
  </template>

  <div class="modal-text">
    <p>Some awesome stuff is in the works. <br />Stay tuned!</p>
  </div>

  <template v-slot:modal-footer="{ hide }">
    <BaseButton class="btn-clear" @click="hide()">
      Back
    </BaseButton>
  </template>
</b-modal>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {},
  computed: {},
  methods: {
    hide() {
      this.$bvModal.hide('coming-soon-modal');
    },
  },
};
</script>

<style lang="scss">
@import 'theme.scss';

.modal-title {
  font-size: 1.7rem;
  font-weight: 600 !important;
  margin-bottom: 2.4rem;
}

.modal-body {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}

.modal-text {
  font-weight: 400;
  text-align: center;
}

.button.btn-clear.btn-clear {
  color: $color-action !important;
  font-size: 1.7rem;
  font-weight: 400;
  margin-top: 3rem;
  text-transform: capitalize !important;
}
</style>
